import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-m-2" }
const _hoisted_2 = { class: "p-m-2" }
const _hoisted_3 = { class: "p-ml-2" }
const _hoisted_4 = { class: "p-m-2" }
const _hoisted_5 = { class: "p-ml-2" }
const _hoisted_6 = { class: "p-m-2" }
const _hoisted_7 = { class: "p-ml-2" }
const _hoisted_8 = { class: "p-m-2" }
const _hoisted_9 = { class: "p-ml-2" }
const _hoisted_10 = { class: "p-m-2" }
const _hoisted_11 = { class: "p-ml-2" }
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_SchedulerSnapshotAccordion = _resolveComponent("SchedulerSnapshotAccordion")
  const _component_SchedulerFileAccordion = _resolveComponent("SchedulerFileAccordion")
  const _component_SchedulerDocumentAccordion = _resolveComponent("SchedulerDocumentAccordion")
  const _component_SchedulerJavaClassAccordion = _resolveComponent("SchedulerJavaClassAccordion")
  const _component_SchedulerMailAccordion = _resolveComponent("SchedulerMailAccordion")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.document.saveassnapshot,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.document.saveassnapshot = $event)),
          binary: true,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeProperty('saveassnapshot'))),
          "data-test": "snapshot-checkbox"
        }, null, 8, ["modelValue"]),
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('managers.scheduler.saveAsSnapshot')), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.document.saveasfile,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.document.saveasfile = $event)),
          binary: true,
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.removeProperty('saveasfile'))),
          "data-test": "file-checkbox"
        }, null, 8, ["modelValue"]),
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('managers.scheduler.saveAsFile')), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.document.saveasdocument,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.document.saveasdocument = $event)),
          binary: true,
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeProperty('saveasdocument'))),
          "data-test": "document-checkbox"
        }, null, 8, ["modelValue"]),
        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('managers.scheduler.saveAsDocument')), 1)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.document.sendtojavaclass,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.document.sendtojavaclass = $event)),
          binary: true,
          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.removeProperty('sendtojavaclass'))),
          "data-test": "java-checkbox"
        }, null, 8, ["modelValue"]),
        _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('managers.scheduler.sendToJavaClass')), 1)
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.document.sendmail,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.document.sendmail = $event)),
          binary: true,
          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.removeProperty('sendmail'))),
          "data-test": "mail-checkbox"
        }, null, 8, ["modelValue"]),
        _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('managers.scheduler.sendMail')), 1)
      ])
    ]),
    (_ctx.document)
      ? (_openBlock(), _createBlock("div", _hoisted_12, [
          (_ctx.document.saveassnapshot)
            ? (_openBlock(), _createBlock(_component_SchedulerSnapshotAccordion, {
                key: 0,
                class: "p-m-3",
                propDocument: _ctx.document,
                "data-test": "snapshot-accordion"
              }, null, 8, ["propDocument"]))
            : _createCommentVNode("", true),
          (_ctx.document.saveasfile)
            ? (_openBlock(), _createBlock(_component_SchedulerFileAccordion, {
                key: 1,
                class: "p-m-3",
                propDocument: _ctx.document,
                "data-test": "file-accordion"
              }, null, 8, ["propDocument"]))
            : _createCommentVNode("", true),
          (_ctx.document.saveasdocument)
            ? (_openBlock(), _createBlock(_component_SchedulerDocumentAccordion, {
                key: 2,
                class: "p-m-3",
                propDocument: _ctx.document,
                functionalities: _ctx.functionalities,
                datasets: _ctx.datasets,
                jobInfo: _ctx.jobInfo,
                "data-test": "document-accordion"
              }, null, 8, ["propDocument", "functionalities", "datasets", "jobInfo"]))
            : _createCommentVNode("", true),
          (_ctx.document.sendtojavaclass)
            ? (_openBlock(), _createBlock(_component_SchedulerJavaClassAccordion, {
                key: 3,
                class: "p-m-3",
                propDocument: _ctx.document,
                "data-test": "java-accordion"
              }, null, 8, ["propDocument"]))
            : _createCommentVNode("", true),
          (_ctx.document.sendmail)
            ? (_openBlock(), _createBlock(_component_SchedulerMailAccordion, {
                key: 4,
                class: "p-m-3",
                propDocument: _ctx.document,
                datasets: _ctx.datasets,
                jobInfo: _ctx.jobInfo,
                documentWithUniqueMail: _ctx.documentWithUniqueMail,
                onSendUniqueMailSelected: _ctx.setSetUniqueMailSelected,
                onUniqueMailOptionsChanged: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('uniqueMailOptionsChanged', $event))),
                "data-test": "mail-accordion"
              }, null, 8, ["propDocument", "datasets", "jobInfo", "documentWithUniqueMail", "onSendUniqueMailSelected"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}